import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import { I18n } from 'react-redux-i18n';

import Button from '../../inputs/button/Button';
import AddForm from '..//addform/AddForm';
import FormActions from '../formactions/FormActions';
import FormField from '../formfield/FormField';
import { ZoneValidations } from '../../../models';

export class ZoneInfoForm extends Component {
  render() {
    let siteid = this.props.zone.site.id;
    let area = this.props.areas[siteid].find(a=>{return a.id === this.props.zone.area.id})
    let site = this.props.sites.find(s=>{return s.id === siteid});
    return (
      <AddForm onSubmit={this.props.handleSubmit}>
        <Field
          name="name"
          label={I18n.t('add.zone.zone.label')}
          type="text"
          placeholder={I18n.t('add.zone.zone.placeholder')}
          component={FormField}
          validate={ZoneValidations.zone}
        />
        <Field
          name="site"
          label={I18n.t('models.area.site')}
          type="value"
          component={FormField}
          input={{value: site.name}}
        />
        <Field
          name="area"
          label={I18n.t('add.zone.area.label')}
          type="value"
          component={FormField}
          input={{value: area.name}}
        />

        <FormActions>
          <Button>{I18n.t('save')}</Button>
        </FormActions>
      </AddForm>
    );
  }
}


export default
  reduxForm({
    form: 'editzone',
  })(ZoneInfoForm);



// WEBPACK FOOTER //
// ./src/components/forms/editzone/ZoneInfoForm.js